export default "__VITE_ASSET__C0E_nRRI__"